import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutColumnItemBreakAfters, UitkLayoutColumnItemBreakBefores, UitkLayoutColumnItemBreakInsides, UitkLayoutColumnItemSpans } from './types.esm.js';
import styles from './uitk-layout-columns.css';
var getClassNameList = classNames.bind(styles);
var UitkLayoutColumnsItem = function (props) {
  var breakAfter = props.breakAfter,
    breakBefore = props.breakBefore,
    breakInside = props.breakInside,
    className = props.className,
    columnSpan = props.columnSpan,
    forceNoBreak = props.forceNoBreak,
    style = props.style;
  var childrenArray = React.Children.toArray(props.children);
  if (!childrenArray.length) {
    return null;
  }
  var firstChild = childrenArray[0];
  var firstChildClassName = firstChild.props.className;
  var firstChildStyle = firstChild.props.style;
  var baseClass = 'uitk-layout-columns-item';
  var wrapperClassNames = getClassNameList(baseClass, firstChildClassName, breakAfter && "".concat(baseClass, "-").concat(UitkLayoutColumnItemBreakAfters.get(breakAfter)), breakBefore && "".concat(baseClass, "-").concat(UitkLayoutColumnItemBreakBefores.get(breakBefore)), breakInside && "".concat(baseClass, "-").concat(UitkLayoutColumnItemBreakInsides.get(breakInside)), columnSpan && "".concat(baseClass, "-").concat(UitkLayoutColumnItemSpans.get(columnSpan)), forceNoBreak && "".concat(baseClass, "-force-no-break"), className);
  var wrapperStyle = __assign(__assign({}, firstChildStyle), style);
  var decoratedChild = React.cloneElement(firstChild, __assign({
    className: wrapperClassNames
  }, Object.keys(wrapperStyle).length && {
    style: wrapperStyle
  }));
  return decoratedChild;
};
export { UitkLayoutColumnsItem };